import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import useAuth from "../../../hooks/useAuth";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login, loading, error } = useAuth();
  const [formData, setFormData] = useState({
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // console.log("Giriş denemesi:", formData);
      const user = await login(formData.phone, formData.password);
      // console.log("Giriş başarılı:", user);
      navigate("/");
    } catch (err) {
      console.error("Giriş hatası:", err); // Hataları loglamak genellikle iyi bir fikirdir.
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center py-12 px-4">
      <div className="w-96 p-8 bg-white rounded-3xl border border-black/20 flex-col justify-start items-center gap-6 inline-flex">
        {/* Logo ve Başlık Bölümü */}
        <div className="self-stretch h-36 flex-col justify-start items-center gap-4 flex">
          <div className="w-48 h-20 relative">
            <img
              src={logo}
              alt="Yıkafoni Logo"
              className="w-[200px] h-[50px]"
            />
            <div className="w-32 text-center text-[#4F46E5] text-xs tracking-wider font-bold mt-1">
              TEMİZLİK BURADA
            </div>
          </div>
          <div className="self-stretch h-14 flex-col justify-start items-start gap-2 flex">
            <div className="self-stretch text-center text-black text-2xl font-semibold leading-loose">
              Giriş Yap
            </div>
            <div className="self-stretch text-center text-black/40 text-sm leading-tight">
              Tekrar hoş geldiniz! Lütfen bilgilerinizi girin.
            </div>
          </div>
        </div>

        {/* Form Bölümü */}
        <form
          onSubmit={handleSubmit}
          className="self-stretch flex-col justify-start items-end gap-4 flex"
        >
          <div className="self-stretch flex-col justify-start items-start gap-3 flex">
            <div className="self-stretch h-16 flex-col justify-start items-start flex">
              <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                <div className="text-black/90 text-sm font-medium leading-tight">
                  Telefon
                </div>
              </div>
              <input
                type="tel"
                name="phone"
                placeholder="5XX XXX XX XX"
                value={formData.phone}
                onChange={handleChange}
                className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
              />
            </div>
            <div className="self-stretch h-16 flex-col justify-start items-start flex">
              <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                <div className="text-black/90 text-sm font-medium leading-tight">
                  Şifre
                </div>
              </div>
              <input
                type="password"
                name="password"
                placeholder="Şifre"
                value={formData.password}
                onChange={handleChange}
                className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
              />
            </div>
          </div>

          {/* Hatırla ve Şifremi Unuttum */}
          <div className="self-stretch justify-between items-center inline-flex">
            <div className="justify-start items-center gap-2 flex">
              <div className="py-0.5 justify-start items-start gap-2 flex">
                <input
                  type="checkbox"
                  className="w-4 h-4 rounded bg-[#4F46E5] border-0 text-white focus:ring-0"
                />
              </div>
              <div className="text-black/90 text-sm font-medium leading-tight">
                30 gün boyunca hatırla
              </div>
            </div>
            <Link
              to="/auth/forgot-password"
              className="text-[#4F46E5] text-sm font-medium leading-tight flex items-center gap-2"
            >
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path
                  d="M14.2125 13.8623L10.1547 9.80449C10.7844 8.99043 11.125 7.99512 11.125 6.94824C11.125 5.69512 10.6359 4.52012 9.75156 3.63418C8.86719 2.74824 7.68906 2.26074 6.4375 2.26074C5.18594 2.26074 4.00781 2.7498 3.12344 3.63418C2.2375 4.51855 1.75 5.69512 1.75 6.94824C1.75 8.1998 2.23906 9.37793 3.12344 10.2623C4.00781 11.1482 5.18438 11.6357 6.4375 11.6357C7.48438 11.6357 8.47813 11.2951 9.29219 10.667L13.35 14.7232C13.3619 14.7351 13.376 14.7446 13.3916 14.751C13.4071 14.7575 13.4238 14.7608 13.4406 14.7608C13.4575 14.7608 13.4741 14.7575 13.4897 14.751C13.5052 14.7446 13.5194 14.7351 13.5312 14.7232L14.2125 14.0436C14.2244 14.0317 14.2338 14.0175 14.2403 14.002C14.2467 13.9864 14.2501 13.9698 14.2501 13.9529C14.2501 13.9361 14.2467 13.9194 14.2403 13.9039C14.2338 13.8883 14.2244 13.8742 14.2125 13.8623Z"
                  fill="#4F46E5"
                />
              </svg>
              Şifremi Unuttum
            </Link>
          </div>

          {/* Hata Mesajı */}
          {error && (
            <div className="self-stretch text-red-500 text-sm text-center">
              {error}
            </div>
          )}

          {/* Butonlar */}
          <div className="self-stretch flex-col justify-start items-center gap-4 flex">
            <button
              type="submit"
              disabled={loading}
              className="self-stretch h-10 px-4 bg-[#4F46E5] rounded-lg shadow-[0px_2px_0px_0px_rgba(0,0,0,0.02)] text-white flex items-center justify-center gap-2 disabled:opacity-50"
            >
              {loading ? (
                "Giriş yapılıyor..."
              ) : (
                <>
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path
                      d="M17.7656 17.2002L12.6934 12.1279C13.4805 11.1104 13.9062 9.86621 13.9062 8.55762C13.9062 6.99121 13.2949 5.52246 12.1895 4.41504C11.084 3.30762 9.61133 2.69824 8.04688 2.69824C6.48242 2.69824 5.00977 3.30957 3.9043 4.41504C2.79687 5.52051 2.1875 6.99121 2.1875 8.55762C2.1875 10.1221 2.79883 11.5947 3.9043 12.7002C5.00977 13.8076 6.48047 14.417 8.04688 14.417C9.35547 14.417 10.5977 13.9912 11.6152 13.2061L16.6875 18.2764C16.7024 18.2912 16.72 18.3031 16.7395 18.3111C16.7589 18.3192 16.7797 18.3233 16.8008 18.3233C16.8218 18.3233 16.8427 18.3192 16.8621 18.3111C16.8815 18.3031 16.8992 18.2912 16.9141 18.2764L17.7656 17.4268C17.7805 17.4119 17.7923 17.3942 17.8004 17.3748C17.8084 17.3554 17.8126 17.3345 17.8126 17.3135C17.8126 17.2924 17.8084 17.2716 17.8004 17.2522C17.7923 17.2327 17.7805 17.2151 17.7656 17.2002Z"
                      fill="white"
                    />
                  </svg>
                  <span className="text-base font-medium">Giriş Yap</span>
                </>
              )}
            </button>

            <button
              type="button"
              className="self-stretch h-10 px-4 bg-white rounded-lg shadow-[0px_2px_0px_0px_rgba(0,0,0,0.02)] border border-black/20 flex items-center justify-center gap-2"
            >
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path
                  d="M17.2076 9.15137H10.151V12.0518H14.1823C14.0084 12.9893 13.4811 13.7822 12.6862 14.3135C12.0143 14.7627 11.1569 15.0283 10.149 15.0283C8.19788 15.0283 6.54749 13.71 5.95764 11.9385C5.8092 11.4893 5.72327 11.0088 5.72327 10.5146C5.72327 10.0205 5.8092 9.54004 5.95764 9.09082C6.54944 7.32129 8.19983 6.00293 10.151 6.00293C11.2506 6.00293 12.2369 6.38184 13.0143 7.12402L15.1627 4.97363C13.8639 3.7627 12.1705 3.02051 10.151 3.02051C7.22327 3.02051 4.69006 4.7002 3.45764 7.14941C2.94983 8.16113 2.66077 9.30566 2.66077 10.5166C2.66077 11.7275 2.94983 12.8701 3.45764 13.8818C4.69006 16.3311 7.22327 18.0107 10.151 18.0107C12.1744 18.0107 13.8698 17.3389 15.108 16.1943C16.524 14.8896 17.3424 12.9678 17.3424 10.6846C17.3424 10.1533 17.2955 9.64355 17.2076 9.15137Z"
                  fill="black"
                  fillOpacity="0.88"
                />
              </svg>
              <span className="text-black/90 text-base font-medium">
                Google ile Giriş Yap
              </span>
            </button>

            {/* Hesap Oluştur */}
            <div className="self-stretch flex-col justify-start items-center gap-2 flex">
              <div className="text-black/40 text-sm">Hesabınız yok mu?</div>
              <Link
                to="/auth/register"
                className="text-[#4F46E5] text-sm font-medium flex items-center gap-2"
              >
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path
                    d="M14.7125 13.8623L10.6547 9.80449C11.2844 8.99043 11.625 7.99512 11.625 6.94824C11.625 5.69512 11.1359 4.52012 10.2516 3.63418C9.36719 2.74824 8.18906 2.26074 6.9375 2.26074C5.68594 2.26074 4.50781 2.7498 3.62344 3.63418C2.7375 4.51855 2.25 5.69512 2.25 6.94824C2.25 8.1998 2.73906 9.37793 3.62344 10.2623C4.50781 11.1482 5.68438 11.6357 6.9375 11.6357C7.98438 11.6357 8.97813 11.2951 9.79219 10.667L13.85 14.7232C13.8619 14.7351 13.876 14.7446 13.8916 14.751C13.9071 14.7575 13.9238 14.7608 13.9406 14.7608C13.9575 14.7608 13.9741 14.7575 13.9897 14.751C14.0052 14.7446 14.0194 14.7351 14.0312 14.7232L14.7125 14.0436C14.7244 14.0317 14.7338 14.0175 14.7403 14.002C14.7467 13.9864 14.7501 13.9698 14.7501 13.9529C14.7501 13.9361 14.7467 13.9194 14.7403 13.9039C14.7338 13.8883 14.7244 13.8742 14.7125 13.8623Z"
                    fill="#4F46E5"
                  />
                </svg>
                Hesap Oluşturun
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
